import { render, staticRenderFns } from "./stuInfo.vue?vue&type=template&id=23fbe196&scoped=true&"
import script from "./stuInfo.vue?vue&type=script&lang=js&"
export * from "./stuInfo.vue?vue&type=script&lang=js&"
import style0 from "./stuInfo.vue?vue&type=style&index=0&id=23fbe196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fbe196",
  null
  
)

export default component.exports